import React, { useEffect } from 'react'
import {
    Navbar,
    IconButton,

} from "@material-tailwind/react";

import AIcon from '../partials/AIcon';
import { SideBarContext } from '../../store/sidebar/context';

import UserProfileMenu from './menus/UserProfileMenu';
import NotificationMenu from './menus/NotificationMenu';
import LanguagesMenu from './menus/LanguagesMenu';

import { useShared } from '../../hooks/useShared';
import logo from './../../assets/images/logo.PNG'
import { Link } from 'react-router-dom';

export default function Header(props) {

   // const { pushSideBar, setPushSideBar } = React.useContext(SideBarContext);
    const { getLanguage } = useShared()
    const { setOpenDrawer,  pushSideBar, setPushSideBar } = useShared()

    return (

        <Navbar className='sticky  z-10 h-max max-w-full rounded-none py-2.5 px-4 lg:pl-2 lg:pr-8 shadow-none bg-main-color border-0  bg-opacity-100'>
            <div className="header-content flex items-center flex-row">

                <div className="lg:mr-4 hidden md:block">
                    <IconButton variant="text" className='text-white-500' onClick={() => setPushSideBar(pre=>!pushSideBar)}>
                        <AIcon size={25} name={!pushSideBar ? "arrow-undo-outline" : "arrow-redo-outline"} className="text-white-500" />
                    </IconButton>
                </div>

                <form action="#">
                    {/*    <div className="hidden md:flex relative w-72">
                        <div className="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400">
                            <AIcon size={20} name="search" />
                        </div>

                        <input
                            id="search"
                            type="text"
                            name="search"
                            className="text-sm sm:text-base  pl-10 pr-4 rounded-lg border border-gray-300 w-full h-10 focus:outline-none focus:border-indigo-400 text-gray-700"
                            placeholder="Search..."
                        />
                    </div> */}



                    <div className="flex md:hidden">
                        <IconButton variant="text" className='text-white-500' onClick={() => setOpenDrawer(true)}>
                            <AIcon size={25} name="menu-sharp" className="text-white-500" />
                        </IconButton>

                    </div>
                </form>


                <div className={`flex   items-center ${getLanguage() === 'dr' ? 'mr-auto' : 'ml-auto'}`}>
                    <NotificationMenu />
                    <UserProfileMenu />
                  

                    <div className="inline-flex md:hidden px-2">
                        <Link to={'/db/dashboard'} className="inline-flex flex-row items-center">
                            <img
                                src={logo}
                                alt="Logo"
                                className="h-9 w-9 bg-gray-200 border border-white rounded-md"
                            />
                        </Link>
                    </div>

                </div>
            </div>
        </Navbar>

    )
}
